/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxBank from "../../../util/remote/ajaxBank";
import AppContainer from "../../../Components/Structure/AppContainer";
import Loader from "../../../Components/Common/Loader";
import TableHeader from "../../../Components/Common/TableHeader";
import CreditBalancesSearchForm from "../../../Components/Common/Statistics/CreditBalancesSearchForm";
import Pagination from "../../../Components/Common/Pagination";
import ajaxVendor from "../../../util/remote/ajaxVendor";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import WalletTransactionsFilterForm from "../../../Components/Common/Transactions/WalletTransactionsFilterForm";


function VendorFloatBalancesPage() {
    const {schoolList} = useContext(SchoolContext);
    const [query, setQuery] = useState("");
    const [school, setSchool] = useState("");
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [overallVendorFloatBalance, setOverallVendorFloatBalance] = useState(false);
    const [vendorFloatBalances, setVendorFloatBalances] = useState([]);
    const [first, setFirst] = useState("");
    const [meta, setMeta] = useState([]);
    const [schoolVendorFloatBalances, setSchoolVendorFloatBalances] = useState([]);
    const [modal, setModal] = useStateCallback(false);
    useEffect(() => {
        if (query || school ) {
            searchVendorFloatBalances();
        } else {
            getVendorFloatBalances(page);
        }
    }, [page]);

    useEffect(() => {
            getOverallVendorFloatBalance();
            getSchoolFloatBalances();
    }, []);

    const getOverallVendorFloatBalance = async () => {
        const server_response = await ajaxBank.fetchOverallFloatVendorBalance();
        if (server_response.status === "OK") {
            setOverallVendorFloatBalance(server_response.details);
        } else {
            setOverallVendorFloatBalance("404");
        }
    };
  
    const getVendorFloatBalances = async (currentPage) => {
        setLoading(true);
        const server_response = await ajaxVendor.listAllVendorFloatBalances(currentPage);
        setLoading(false);

        if (server_response.status === "OK") {
            setFirst(server_response.details.meta.offset);
            setMeta(server_response.details.meta.totalPages);
            setVendorFloatBalances(server_response.details.data || []);
        } else {
            setVendorFloatBalances([]);
        }
    };

    const searchVendorFloatBalances = async (e) => {
        if (e) {
            e.preventDefault();
        }
        setLoading2(true);
        const server_response = await ajaxVendor.searchAllVendorFloatBalances(page, school, query);
        setLoading2(false);
        if (server_response.status === "OK") {
            setMeta(server_response.details.meta.totalPages);
            setVendorFloatBalances(server_response.details.data || []);
        } else {
            setVendorFloatBalances([]);
        }
    };

    // const printPocketMoneyBalances = async () => {
    //     setLoading(true);
    //     const server_response = await ajaxStudent.printAllStudentPocketMoneyBalances();
    //     setLoading(false);
    //     if (server_response.status === "OK") {
    //         setPrintablePocketMoneyBalances(server_response.details);
    //     } else {
    //         setPrintablePocketMoneyBalances([]);
    //     }
    // };

const getSchoolFloatBalances = async () => {
    setLoading3(true);
    const server_response = await ajaxVendor.fetchAllSchoolFloatBalances();
    setLoading3(false);
    if (server_response.status === "OK") {
        setSchoolVendorFloatBalances(server_response.details || []);  
    } else {
        setSchoolVendorFloatBalances([]);
    }
};

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const setBalances = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("");
    setPage(1);
    getVendorFloatBalances(1);
    
  };

  const filterStats = (e, item) => {
      setModal(false, () => setModal(<WalletTransactionsFilterForm user={item.user} userID={item.user_id} username={item.username}
          balance={item.balance.total_c} isOpen={true}/>));
    }


  return (
    <AppContainer title="Vendor Float Balances">
      <Toaster position="top-center" reverseOrder={false} />
        {modal}
       
        <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            UGX. {overallVendorFloatBalance? overallVendorFloatBalance:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> Float Balance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-lg-9 col-md-12 col-12 col-sm-12">
                <div className="row">
                <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Float Balances List"
          subtitle="List of all the vendors with their float balances sorted from highest to lowest"    
        />
        <div class="dropdown">
            
          {/* <a class="dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">...</a> */}
          <Link class="" onClick={setBalances} role="button"><i class="fas fa-redo-alt ml-3"></i></Link>
          {/* <Link class="" onClick={exportToPDF} role="button"><i class="fas fa-download ml-3"></i></Link>
        <Link class="" onClick={exportToExcel} role="button"><i class="fas fa-file-excel ml-3"></i></Link> */}
          
        </div>
      </div>

      <CreditBalancesSearchForm school={school} student={query} setSchool={setSchool} setStudent={setQuery}
      searchCreditBalances={searchVendorFloatBalances} setPage={setPage} resetSearch={setBalances} schoolList={schoolList}/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">No.</th>
                <th scope="col">Vendor Name</th>
                <th scope="col">Username</th>

                <th scope="col"> School</th>
                <th scope="col"> Float Balance</th>
                
                </tr>
            </thead>
            <tbody>
                {vendorFloatBalances.length > 0 ? (
                    vendorFloatBalances.map((item, index) => (
                    <tr key={index}>
                        

                        <td>{index + first + 1} </td>
                        <td><OverlayTrigger placement="top" overlay={
                                                                <Tooltip id="refresh-tooltip">
                                                                    View Statement
                                                                </Tooltip>}><Link onClick={(e) => filterStats(e,item)}>{item.user}
                                                                </Link></OverlayTrigger></td>
                        {/* <td><OverlayTrigger placement="top" overlay={
                                                                <Tooltip id="refresh-tooltip">
                                                                    View Statement
                                                                </Tooltip>}><Link to={`/vendor-balances/statement/${item.user_id}?username=${encodeURIComponent(item.username)}&user=${encodeURIComponent(item.user)}&balance=${encodeURIComponent(item.balance.total_c)}`}>{item.user}
                                                                </Link></OverlayTrigger></td> */}
                        
                        <td>{item.username}</td>

                        <td>{item.school}</td>
                        <td>UGX. {item.balance.total_c}</td>

                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                            No vendors registered yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
                
                
                </div>
            </div>
            <div class="col-lg-3 col-md-12 col-12 col-sm-12">
                            <div className="row">
                            {loading3 ? (
                                <Loader />
                                  ):(
                                    schoolVendorFloatBalances.map((item, index) => (
                                        <div key={index} class="col-lg-12 col-md-12 col-12 col-sm-12">
                                            <div class="card custom-card">
                                                <div class="card-body">
                                                    <div>
                                                        <h6>{item.school_name}</h6>
                                                        <h6><span class="fs-30 me-2" style={{fontSize:"20px"}}>UGX. {item.balance?item.balance.total_c:"..."}</span></h6>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>)))}
                                       
                                
                                
                            </div>
                        </div>
        </div>
        

        
      
    </AppContainer>
  );
}

export default VendorFloatBalancesPage;
